import React from 'react'
import { Chip, Tooltip } from '@material-ui/core'
import { Block as BlockIcon } from '@material-ui/icons'
import { format, formatDistanceToNow, parseISO, isValid } from 'date-fns'

/** Shape shared by full `Prospect` and nested prospect on enrollment rows */
export type CampaignEmailUnsubscribeProspectLike = {
    email_unsubscribed_at?: string | null
}

export const isGloballyUnsubscribedFromCampaignEmails = (
    p: CampaignEmailUnsubscribeProspectLike | null | undefined,
): p is CampaignEmailUnsubscribeProspectLike & {
    email_unsubscribed_at: string
} => !!(p?.email_unsubscribed_at && String(p.email_unsubscribed_at).trim())

export function formatCampaignEmailUnsubscribeTooltip(iso: string): string {
    try {
        const d = parseISO(iso)
        if (!isValid(d)) {
            return 'This prospect unsubscribed via the link in a campaign email. They will not receive further campaign marketing emails.'
        }
        const absolute = format(d, 'MMM d, yyyy · h:mm a')
        const relative = formatDistanceToNow(d, { addSuffix: true })
        return `Unsubscribed from campaign marketing emails on ${absolute} (${relative}). They will not receive further campaign emails.`
    } catch {
        return 'This prospect unsubscribed from campaign marketing emails. They will not receive further campaign emails.'
    }
}

/** Campaign email opt-out only — not SMS or account access */
export const CampaignEmailUnsubscribeIndicator: React.FC<{
    prospect: CampaignEmailUnsubscribeProspectLike | null | undefined
}> = ({ prospect }) => {
    if (!isGloballyUnsubscribedFromCampaignEmails(prospect)) {
        return null
    }

    const at = prospect.email_unsubscribed_at

    return (
        <Tooltip
            title={formatCampaignEmailUnsubscribeTooltip(at)}
            placement="top"
            arrow
        >
            <span style={{ display: 'inline-flex', maxWidth: '100%' }}>
                <Chip
                    icon={
                        <BlockIcon
                            style={{
                                height: 14,
                                width: 14,
                                marginLeft: 4,
                            }}
                        />
                    }
                    label="Unsubscribed from emails"
                    size="small"
                    style={{
                        maxWidth: '100%',
                        height: 22,
                        fontSize: '0.7rem',
                        fontWeight: 600,
                        backgroundColor: '#fef2f2',
                        color: '#991b1b',
                        border: '1px solid #fecaca',
                    }}
                />
            </span>
        </Tooltip>
    )
}
